__webpack_require__.p = "//static01-verify.we.goodwe.com/static/web-business-components/2.9.13/";